import MealImage from 'src/components/MealImage'
import './OrderSummaryMeal.scss'

import { getMealPriceByBox } from 'src/utils/menu'
import { formatFixedPrice } from 'src/utils/utils'

export const OrderSummaryMeal = ({
  meal,
  isBOM = false,
  currentBox,
  useBOMMultiplePrices
}) => {
  const priceToShow = () => {
    let mealPrice = meal.finalPrice

    if (useBOMMultiplePrices && currentBox) {
      const boxPrice = getMealPriceByBox(meal.prices, currentBox)
      mealPrice = boxPrice?.finalPrice ?? meal.finalPrice
    }
    return formatFixedPrice(mealPrice)
  }

  return (
    <div className="order-summary-meal">
      <div className="order-summary-meal-image-container">
        <MealImage
          mealImage={meal.image}
          classNameImage="order-summary-meal-image"
          withoutText
        />
      </div>
      <div className="order-summary-meal-content">
        <span className="order-summary-meal-content-name">{meal.mealName}</span>
        {isBOM && (
          <div className="order-summary-meal-content-price">
            {priceToShow()}
          </div>
        )}
      </div>
      <div className="order-summary-meal-counter">
        <span className="order-summary-meal-counter-text">
          {meal.quantity || meal.qty}
        </span>
      </div>
    </div>
  )
}
